module.exports = __webpack_public_path__ + "static/media/creative-services-icon.fd0fbf3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/creative-services-icon.svg
// module id = 1918
// module chunks = 0